"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var LoadingError = function LoadingError() {
  var middle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: middle
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card, {
      className: "text-center mt-2"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card.Body, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card.Title, null,
    /*#__PURE__*/
    _react["default"].createElement("h2", null, "The document is not available"),
    /*#__PURE__*/
    _react["default"].createElement("hr", null),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "text-center"
    },
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "50",
      height: "50",
      viewBox: "0 0 172 172"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: "1",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: "10",
      strokeDasharray: "",
      strokeDashoffset: "0",
      fontFamily: "none",
      fontWeight: "none",
      fontSize: "none",
      textAnchor: "none"
    },
    /*#__PURE__*/
    _react["default"].createElement("path", {
      d: "M0,172v-172h172v172z",
      fill: "none"
    }),
    /*#__PURE__*/
    _react["default"].createElement("g", {
      fill: "#3498db"
    },
    /*#__PURE__*/
    _react["default"].createElement("path", {
      d: "M99.73313,29.40125c-17.93906,0 -33.05625,10.70969 -40.35281,25.88063c-3.89688,-2.6875 -8.35813,-4.63594 -13.4375,-4.63594c-12.77906,0 -23.05875,10.11844 -23.82469,22.70938c-12.80594,4.63594 -22.11813,16.60875 -22.11813,30.97344c0,18.34219 14.92906,33.27125 33.27125,33.27125h108.10469c16.8775,0 30.62406,-13.74656 30.62406,-30.62406c0,-15.65469 -11.99969,-28.13812 -27.1975,-29.92531c0.05375,-0.80625 0.16125,-1.58563 0.16125,-2.41875c0,-24.94 -20.29062,-45.23063 -45.23062,-45.23063zM99.73313,36.28125c21.23125,0 38.35062,17.13281 38.35062,38.35063c0,1.57219 -0.12094,3.14437 -0.3225,4.75687l-0.48375,3.85656h3.89688c0.41656,0 0.47031,0 0.20156,0c13.15531,0 23.74406,10.58875 23.74406,23.73062c0,13.15531 -10.58875,23.74406 -23.74406,23.74406h-108.10469c-14.62,0 -26.39125,-11.77125 -26.39125,-26.39125c0,-12.16094 8.21031,-22.31969 19.35,-25.39687l2.62031,-0.72563l-0.09406,-2.70094c-0.01344,-0.48375 -0.04031,-0.72563 -0.04031,-0.7525c0,-9.55406 7.67281,-17.22688 17.22688,-17.22688c4.78375,0 9.07031,1.935 12.18781,5.0525l3.78937,3.80281l1.88125,-5.03906c5.40188,-14.60656 19.39031,-25.06094 35.93188,-25.06094zM65.36,75.68c-3.80281,0 -6.88,3.07719 -6.88,6.88c0,3.80281 3.07719,6.88 6.88,6.88c3.80281,0 6.88,-3.07719 6.88,-6.88c0,-3.80281 -3.07719,-6.88 -6.88,-6.88zM106.64,75.68c-3.80281,0 -6.88,3.07719 -6.88,6.88c0,3.80281 3.07719,6.88 6.88,6.88c3.80281,0 6.88,-3.07719 6.88,-6.88c0,-3.80281 -3.07719,-6.88 -6.88,-6.88zM86,99.76c-20.70719,0 -33.55344,14.9425 -33.55344,14.9425c-0.84656,0.92719 -1.12875,2.24406 -0.72563,3.42656c0.38969,1.1825 1.41094,2.06937 2.63375,2.28437c1.23625,0.22844 2.49938,-0.22844 3.27875,-1.19594c0,0 10.97844,-12.5775 28.36656,-12.5775c17.38813,0 28.36656,12.5775 28.36656,12.5775c0.77937,0.9675 2.0425,1.42438 3.27875,1.19594c1.22281,-0.215 2.24406,-1.10187 2.63375,-2.28437c0.40312,-1.1825 0.12094,-2.49938 -0.72563,-3.42656c0,0 -12.84625,-14.9425 -33.55344,-14.9425z"
    })))))),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card.Text, null, "Retry later or contact support at @"))))
  );
};

var _default = exports["default"] = LoadingError;